<template>
  <div class="adminDeviceSidebarNew">
    <div
      class="closeBtn"
      @click="closeSidebar"
      v-if="(vcodeBox == '08' ||  $store.state.user.riyueyuanPermissionMark) && $store.state.user.role == 2"
    >
      <i
        :class="
          sideBarCollapse ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'
        "
      ></i>
    </div>
    <div class="sidebar-list" id="sidebar-list">
      <!-- <span>当前角色：{{this.$store.state.user.role}}</span> -->
      <div class="sidebarViewBox">
        <!-- 侧栏查看设备列表 -->
        <!-- {{$t('datalogger.add')}} -->
        <!-- @click="sidebarViewDevice" -->
        <div v-if="!disPermissionsLogo || btnList.includes('device_list')">
          <div class="titletype">{{ $t("device.device") }}</div>
          <button
            type="button"
            class="btn-view"
            :class="{ activeBtnView: currentBtnViewIndex == 1 }"
            @click="enterDeviceBox({ index: 1 })"
          >
            <span class="ico-view ico-view-device">
              <i class="iconfont icon-a-mingchengnibianqi2 iconstyle"></i>
            </span>
            <!-- <span class="text-view" sty>{{ $t('device.deviceList') }}</span> -->
            <el-tooltip
              effect="dark"
              :disabled="!tooltipFlag"
              :content="$t('device.deviceList')"
              placement="right"
            >
              <span
                @mouseenter="visibilityChange($event)"
                class="text-view"
                sty
                >{{ $t("device.deviceList") }}</span
              >
            </el-tooltip>
          </button>
        </div>

        <!-- 侧栏查看数采器列表 -->
        <!-- @click="enterDataloggerBox" -->
        <div v-if="!disPermissionsLogo || btnList.includes('collector_list')">
          <div class="titletype">{{ $t("device.datalogger") }}</div>
          <button
            type="button"
            class="btn-view"
            :class="{ activeBtnView: currentBtnViewIndex == 2 }"
            @click="enterDataloggerBox({ index: 2 })"
          >
            <span class="ico-view ico-view-datalogger">
              <i class="iconfont icon-a-mingchengcaijiqi3"></i>
            </span>
            <!-- <span class="text-view">{{ $t('device.dataloggerList') }}</span> -->
            <el-tooltip
              effect="dark"
              :disabled="!tooltipFlag"
              :content="$t('device.dataloggerList')"
              placement="right"
            >
              <span
                @mouseenter="visibilityChange($event)"
                class="text-view"
                sty
                >{{ $t("device.dataloggerList") }}</span
              >
            </el-tooltip>
          </button>
        </div>
        <!-- 侧栏查看项目列表 -->
        <div v-if="!disPermissionsLogo || btnList.includes('project_list')">
          <div class="titletype">{{ $t("device.pro") }}</div>
          <button
            type="button"
            class="btn-view"
            :class="{ activeBtnView: currentBtnViewIndex == 4 }"
            @click="enterProjectBox({ index: 4 })"
          >
            <span class="ico-view ico-view-project">
              <i class="iconfont icon-xiangmuguanli"></i>
            </span>
            <!-- <span class="text-view">{{ $t('device.proList') }}</span> -->
            <el-tooltip
              effect="dark"
              :disabled="!tooltipFlag"
              :content="$t('device.proList')"
              placement="right"
            >
              <span
                @mouseenter="visibilityChange($event)"
                class="text-view"
                sty
                >{{ $t("device.proList") }}</span
              >
            </el-tooltip>
          </button>
        </div>
         <!-- 硕日导出记录定制 -->
          <button
            v-if="vcodeBox == 'A5'"
            type="button"
            class="btn-view"
            :class="{ activeBtnView: currentBtnViewIndex == 5 }"
            @click="enterRuoRiExportRecordsBox({ index: 5 })"
          >
            <span class="ico-view ico-view-project">
              <i class="iconfont icon-xiangmuguanli"></i>
            </span>
            <el-tooltip
              effect="dark"
              :disabled="!tooltipFlag"
              :content="$t('shuoriExport.exportRecords')"
              placement="right"
            >
              <span
                @mouseenter="visibilityChange($event)"
                class="text-view"
                >{{ $t("shuoriExport.exportRecords") }}</span>
            </el-tooltip>
          </button>
        <!-- 侧栏查看关注列表(暂时隐藏) -->
        <!-- @click="enterFollowBox({index:3})" -->
        <!-- <button
          type="button"
          class="btn-view"
          :class="{'activeBtnView':currentBtnViewIndex==3}"
          @click="enterFollowBox({index:3, currentIsFollow:true})"
        >
          <span class="ico-view ico-view-follow">
            <i class="iconfont icon-yiguanzhu"></i>
          </span>
          <span class="text-view">{{$t('device.followList')}}</span>
        </button> -->
      </div>

      <!-- 添加设备(转移到侧栏切换的数采器列表上方) -->
      <!-- <el-button
        icon="el-icon-add" 
        v-if="this.$store.state.user.role==2"
        @click="dialogDataloggerVisible=true"
      >{{$t('datalogger.add')}}</el-button> -->

      <!-- v-if="this.$store.state.user.role==2" -->
      <!-- <div 
        class="spliteline"
      ></div> -->

      <!-- 搜索项目 -->
      <!-- <el-input
        :placeholder="$t('account.searchPro')"
        prefix-icon="el-icon-search"
        v-model="search.search"
        style="width:206px;"
        class="search-input"
        @keyup.enter.native="getProjectList"
      ></el-input> -->

      <!-- 项目切换 -->

      <!-- 显示模式（未用已删） -->

      <!-- 定位侧栏底部 -->
      <!-- 管理员-编辑设备控制权限 -->
      <!-- <div class="searchRight">
        <button
          v-if="this.$store.state.user.role ==1"
          class="button-solid button"
          @click="editDeviceControl"
        >{{$t('device.edit_control')}}</button>
      </div> -->
      <!-- <div class="project-box" v-if="this.$store.state.user.role ==1">
        <button class="project-create" @click="editDeviceControl">
          <i class="iconfont icon-shezhi"></i>
          {{$t('device.edit_control')}}
        </button>
      </div> -->
      <!-- 经销商-项目 -->
      <!-- <div class="project-box" v-else> -->
      <!-- 新建项目 -->
      <!-- @click="showCreateProject=true;" -->
      <!-- <button class="project-create" @click="createProject">
          <i class="iconfont icon-xinjianxiangmu"></i>
          {{$t('project.createProject')}}
        </button> -->
      <!-- <div class="project-line"></div> -->
      <!-- 项目管理 -->
      <!-- <button class="project-manage" @click="enterProject">
          <i class="iconfont icon-xiangmuguanli"></i>
          {{$t('project.manageProject')}}
        </button> -->
      <!-- </div> -->
    </div>

    <!-- 管理员 - 编辑设备控制权限弹框 -->
    <!-- v-if="editDeviceControlVisible" -->
    <!-- :class="{'showDialog': editDeviceControlVisible, 'hideDialog': !editDeviceControlVisible}" -->
    <control-dialog
      :visible.sync="editDeviceControlVisible"
      v-if="editDeviceControlVisible"
      :title="$t('device.edit_control')"
      width="1125px"
      class="authorityModal"
      noFooter
    >
      <div slot="content">
        <div class="editControl">
          <div class="searchprotocol">
            <!-- 设备权限 -->
            <div class="searchName">
              {{ `${$t("device.Equipment_agreement")}：` }}
            </div>
            <el-select
              v-model="searchProtocol"
              :placeholder="$t('device.Equipment_agreement')"
              popper-class="select-search-recharge"
              @change="getProtocolData"
            >
              <el-option
                v-for="item in protocolAllData"
                :key="item.desc"
                :value="item.devcode"
                :label="item.desc"
              ></el-option>
            </el-select>
          </div>
          <div class="personProtocol">
            <!-- 业主权限 -->
            <!-- $t('device.person_cansee') -->
            <div class="contentLeft">
              <!-- {{`${$t('device.person_authority')}：`}} -->
              <div class="top">
                {{ `${$t("device.person_authority")}：` }}
                <el-checkbox
                  v-model="CheckAllPerson"
                  @change="checkAllPerson"
                  >{{ $t("device.Check_all") }}</el-checkbox
                >
                <el-checkbox v-model="CheckNoPerson" @change="checkNoPerson">{{
                  $t("device.Cancel_all")
                }}</el-checkbox>
              </div>
            </div>
            <div class="contentRight">
              <!-- <div class="top">
                <el-checkbox
                  v-model="CheckAllPerson"
                  @change="checkAllPerson"
                >{{$t('device.Check_all')}}</el-checkbox>
                <el-checkbox
                  v-model="CheckNoPerson"
                  @change="checkNoPerson"
                >{{$t('device.Cancel_all')}}</el-checkbox>
              </div> -->
              <div class="protoclContents" v-if="protocolDataShow">
                <el-checkbox-group v-model="checkPersonData">
                  <el-checkbox
                    v-for="item in checkStatueData"
                    :label="item.name"
                    :title="item.name"
                    :key="item.id"
                    class="checkboxUnit"
                    @change="protoclPersonChange(item)"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div class="noData" v-else>{{ $t("message.nodata") }}</div>
            </div>
          </div>
          <div class="adminProtocol">
            <!-- 管理员权限 -->
            <!-- $t('device.administrator_cansee') -->
            <div class="contentLeft">
              <!-- {{`${$t('device.admin_authority')}：`}} -->
              <div class="top">
                {{ `${$t("device.admin_authority")}：` }}
                <el-checkbox v-model="CheckAllAdmin" @change="checkAllAdmin">{{
                  $t("device.Check_all")
                }}</el-checkbox>
                <el-checkbox v-model="CheckNoAdmin" @change="checkNoAdmin">{{
                  $t("device.Cancel_all")
                }}</el-checkbox>
              </div>
            </div>
            <div class="contentRight">
              <!-- <div class="top">
                <el-checkbox
                  v-model="CheckAllAdmin"
                  @change="checkAllAdmin"
                >{{$t('device.Check_all')}}</el-checkbox>
                <el-checkbox
                  v-model="CheckNoAdmin"
                  @change="checkNoAdmin"
                >{{$t('device.Cancel_all')}}</el-checkbox>
              </div> -->
              <div class="protoclContents" v-if="protocolDataShow">
                <el-checkbox-group v-model="checkAdminData">
                  <el-checkbox
                    v-for="item in checkStatueData"
                    :label="item.name"
                    :title="item.name"
                    :key="item.id"
                    class="checkboxUnit"
                    @change="protoclAdminChange(item)"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div class="noData" v-else>{{ $t("message.nodata") }}</div>
            </div>
          </div>
        </div>
      </div>
    </control-dialog>

    <!-- 添加数采器 -->
    <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      v-if="dialogDataloggerVisible"
      @submitSucAdd="handleCreateSuc"
      @submitFailAdd="handleCreateFail"
    ></datalogger-dialog>
    <!-- 添加结果提示(成功) -->
    <!-- v-if="dataloggerAddSucVisible" -->
    <device-dialog
      :title="$t('datalogger.addResults')"
      :visible.sync="dataloggerAddSucVisible"
      :class="{
        showDialog: dataloggerAddSucVisible,
        hideDialog: !dataloggerAddSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{
            $t("datalogger.addedSuccessfully")
          }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <div class="showoperate">
            <!-- 继续添加 -->
            <button
              type=""
              class="btn btn-light"
              style="margin-right: 10px"
              @click="
                dataloggerAddSucVisible = false;
                dialogDataloggerVisible = true;
              "
            >
              {{ $t("datalogger.continueAdding") }}
            </button>
            <!-- 完成 -->
            <button
              class="btn btn-dark"
              @click="dataloggerAddSucVisible = false"
            >
              {{ $t("datalogger.finish") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 添加结果提示(失败) -->
    <!-- v-if="dataloggerAddFailVisible" -->
    <device-dialog
      :title="$t('datalogger.addResults')"
      :visible.sync="dataloggerAddFailVisible"
      :class="{
        showDialog: dataloggerAddFailVisible,
        hideDialog: !dataloggerAddFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <div class="showoperate">
            <!-- 暂不添加 -->
            <button
              class="btn btn-light"
              style="margin-right: 10px"
              @click="dataloggerAddFailVisible = false"
            >
              {{ $t("datalogger.nowNoAdd") }}
            </button>
            <!-- 重新添加 -->
            <button
              type=""
              class="btn btn-dark"
              @click="
                dataloggerAddFailVisible = false;
                dialogDataloggerVisible = true;
              "
            >
              {{ $t("datalogger.reAdd") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 新建项目 -->
    <!-- v-if="createProjectVisible" -->
    <device-dialog
      :title="$t('project.createProject')"
      :visible.sync="createProjectVisible"
      :class="{
        showDialog: createProjectVisible,
        hideDialog: !createProjectVisible,
      }"
      noFooter
    >
      <div slot="content">
        <el-form slot="content" class="grid">
          <el-form-item :label="`${$t('project.projectName')}:`" size="small">
            <el-input v-model="pFormData.name" clearable></el-input>
          </el-form-item>
          <!-- 上传图片 -->
          <el-form-item label=" " prop="picSmall">
            <div style="text-align: center">
              <img :src="pFormData.picSmall ? pFormData.picSmall : ''" />
            </div>
            <div class="upload-contents" v-if="upbtnVisible">
              <button
                class="upload-buttonEquipment"
                @click.prevent="$refs.fileUploader.click()"
              >
                <i class="iconfont icon-shangchuan1"></i>
              </button>
              <div class="upload-tip">
                {{ `${$t("project.upload")} (${$t("project.limit")})` }}
              </div>
              <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="image/jpeg, image/png"
                @change="uploadImage($event)"
              />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <button class="btn btn-dark" @click="submitCreateProject">
            {{ $t("device.confirm") }}
          </button>
        </div>
      </div>
    </device-dialog>
    <!-- 新建项目结果提示(成功) -->
    <!-- v-if="createProjectSucVisible" -->
    <device-dialog
      :title="$t('project.createResults')"
      :visible.sync="createProjectSucVisible"
      :class="{
        showDialog: createProjectSucVisible,
        hideDialog: !createProjectSucVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t("project.createSuc") }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button
              class="btn btn-dark"
              @click="createProjectSucVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 新建项目结果提示(失败) -->
    <!-- v-if="createProjectFailVisible" -->
    <device-dialog
      :title="$t('project.createResults')"
      :visible.sync="createProjectFailVisible"
      :class="{
        showDialog: createProjectFailVisible,
        hideDialog: !createProjectFailVisible,
      }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              class="btn btn-dark"
              @click="createProjectFailVisible = false"
            >
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex';
import dataloggerDialog from "@/components/dialognew/dataloggernew";
import deviceDialog from "@/components/dialognew";
import controlDialog from "@/components/dialognew/flowIndex";
import { i18n } from "@/i18n";
export default {
  components: {
    dataloggerDialog,
    deviceDialog,
    controlDialog,
  },
  props: {
    // deviceList: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // },
    currentBtnViewIndexProp: {
      type: Number,
    },
  },
  data() {
    return {
      tooltipFlag: false,
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo: sessionStorage.getItem("disPermissionsLogo")
        ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
        : false,
      // 页面权限集合
      btnList: sessionStorage.getItem("firstPageArr")
        ? JSON.parse(sessionStorage.getItem("firstPageArr"))
        : [],
      // statusDic: this.$filter.deviceStatus,
      // 创建数采器弹窗
      dialogDataloggerVisible: false,
      // 项目下设备列表
      deviceList: [],
      // // 筛选条件
      // search: {
      //   status: "",
      //   brand: "",
      //   pn: "",
      //   // 搜索内容
      //   search: "",
      // },
      //分页数据
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0,
      },
      selectedOption: "",
      searchOptions: [
        {
          label: "设备状态",
          options: [
            {
              label: "所有状态",
              value: "000",
              // name: 'normal',
              // class: 'status-normal',
            },
            {
              // label: i18n.t('statistic.normal'),
              label: "正常",
              value: "aaa",
              // name: 'normal',
              // class: 'status-normal',
            },
            {
              label: "离线",
              value: "bbb",
              // name: 'offline',
              // class: 'status-offline',
            },
          ],
          // options: this.$filter.deviceStatus
        },
        {
          label: "设备类型",
          // options: [{
          //   value: 'ccc',
          //   label: 'CCC'
          // }, {
          //   value: 'ddd',
          //   label: 'DDD'
          // }],
          options: this.$filter.deviceType,
        },
      ],
      inputtxt: "",
      // 筛选-设备状态表($filter)
      deviceStatusNew: {
        0: {
          label: i18n.t("statistic.normal"),
          class: "status-normal",
          name: "normal",
        },
        1: {
          label: i18n.t("statistic.offline"),
          class: "status-offline",
          name: "offline",
        },
        2: {
          label: i18n.t("statistic.fault"),
          class: "status-fault",
          name: "fault",
        },
        3: {
          label: i18n.t("statistic.standby"),
          class: "status-standby",
          name: "standby",
        },
        4: {
          label: i18n.t("statistic.warning"),
          class: "status-warning",
          name: "warning",
        },
      },
      // 筛选-设备类型($filter)
      deviceTypeNew: {
        0: {
          value: "0",
          label: i18n.t("device.brand0"),
        },
        1: {
          value: "1",
          label: i18n.t("device.brand1"),
        },
        2: {
          value: "2",
          label: i18n.t("device.brand2"),
        },
        3: {
          value: "3",
          label: i18n.t("device.brand3"),
        },
      },
      // 显示模式
      showmode: 1,
      hiddenTableHeader: false,
      // 项目列表
      proList: [],
      // 当前选中项目名称
      proCurrentName: "",
      // 当前选中项目ID
      proCurrentPid: "",
      // 是否关注
      // focus: false,
      // 显示新建项目
      // showCreateProject: false,
      // 项目操作
      createProjectVisible: false,
      // 项目新建与编辑
      pFormData: {
        name: "",
        picBig: "",
        picSmall: "",
      },
      // 上传图片弹窗按钮
      upbtnVisible: true,
      // 数采器添加成功提示弹窗
      dataloggerAddSucVisible: false,
      // 数采器添加失败提示弹窗
      dataloggerAddFailVisible: false,
      // 新建项目成功提示弹窗
      createProjectSucVisible: false,
      // 新建项目失败提示弹窗
      createProjectFailVisible: false,
      // 操作返回提示(错误时)
      dataloggerTipMsg: "",
      // 侧边栏加载
      loadingdevice: false,
      // 当前点中设备
      devCurrentSn: "",
      // 管理员-控制权限弹框 =====
      editDeviceControlVisible: false,
      protocolIdBox: null, //控制项全部ID
      protocolNameBox: null, //控制项全部名称
      vcodeBox: "", //厂家编号的盒子
      CheckAllPerson: false,
      CheckAllAdmin: false,
      CheckNoPerson: false,
      CheckNoAdmin: false,
      checkAdminData: null,
      checkPersonData: null,
      checkStatueData: null,
      protocolDataShow: true,
      protocolAllData: null,
      searchProtocol: "",
      // noDataControl: false,
      // emptyText: false,
      // 当前选中项目
      currentProId: "",
      // 当前选中列表查看索引(默认显示设备总列表)
      currentBtnViewIndex: 1,
      // currentBtnViewIndex: JSON.parse(sessionStorage.getItem("firstPageArr"))[0]=="device_list"?1:(JSON.parse(sessionStorage.getItem("firstPageArr"))[0]=="collector_list"?2
      // :(JSON.parse(sessionStorage.getItem("firstPageArr"))[0]=="project_list"?3:1)),
      // 侧栏项目列表加载更多
      paginationPro: {
        currentPage: 1,
        pagesize: 10,
        total: 0,
      },
      // 侧栏加载更多Loading
      loadingMorePro: false,
      sideBarCollapse: true,
    };
  },
  computed: {
    // ...mapGetters({
    //   deviceInfo: 'getDeviceInfo'
    // }),
    // watchshowmode(){
    //   return this.showmode
    // },
    // deviceStatus () {
    //   return this.$filter.deviceStatus[this.deviceInfo.status]
    // },
    // 切换项目
    // proCurrentPidShow() {
    //   return this.proCurrentPid;
    // },
    proCurrentNameShow() {
      var valer;
      this.proList.forEach((element) => {
        if (element.pid == this.proCurrentPid) {
          valer = element.pname;
        }
      });
      // console.log('监听属性valer', valer);
      return valer || "";
    },
  },
  watch: {
    // 响应更新电站列表事件
    "$store.state.event.updateProjectList"(val) {
      if (val) {
        this.getProjectList(true);
        this.$store.state.event.updateProjectList = false;
      }
    },
    // 设备详情返回设备列表通知侧栏按钮激活
    currentBtnViewIndexProp(val) {
      // console.log("watch-currentBtnViewIndexProp", val);
      if (val) {
        // 先清空Store中的curIsFollow(后续需要再设置)
        this.$store.commit("saveCurIsFollow", {
          curIsFollow: false,
        });
        this.currentBtnViewIndex = val;
      }
    },
  },
  created() {
    // 【暂时关闭！！！】
    // this.getProjectList();
    // [经销商]
    // if (this.$store.state.user.role == 2) {
    //   this.getProjectList();
    // }

    // this.getDeviceList();

    var arr = sessionStorage.getItem("moduleArr")
      ? JSON.parse(sessionStorage.getItem("moduleArr"))
      : [];
    var arrElse = sessionStorage.getItem("firstPageArr")
      ? JSON.parse(sessionStorage.getItem("firstPageArr"))
      : [];
    let val = sessionStorage.getItem("disPermissionsLogo")
      ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
      : false;
    if (this.$store.state.user.role == 2 && arr.length > 0 && val) {
      this.currentBtnViewIndex = arrElse.includes("device_list")
        ? 1
        : arrElse.includes("collector_list")
        ? 2
        : arrElse.includes("project_list")
        ? 4
        : 1;
    }
    // 查询此管理员的厂家编号vcode用于控制权限
    this.getVcodeData();
  },
  mounted() {},
  methods: {
    // tooltip的可控（解决文字过长的处理）
    visibilityChange(event) {
      const ev = event.target;
      const ev_weight = ev.scrollWidth; // 文本的实际宽度
      const content_weight = ev.clientWidth; // 文本的可视宽度
      if (ev_weight > content_weight) {
        // 文本宽度 > 实际内容宽度  -->内容溢出,则显示悬浮
        this.tooltipFlag = true;
      } else {
        // 否则为未溢出，不显示悬浮
        this.tooltipFlag = false;
      }
    },
    //获取项目列表数据
    getProjectList() {
      let param = {
        i18n: this.$lang.currentLang,
        devtype: 2304,
        // 项目过多时处理
        page: 0,
        // page: this.paginationPro.currentPage - 1,
        pagesize: this.paginationPro.pagesize,
        // 项目ID plantid
        // plantName: this.search.search,
      };
      this.loadingdevice = true;
      // queryPlantsInfoEs => queryPlantCollDevEs
      this.$request.get("queryPlantsInfoEs", param).then((res) => {
        // console.log("【adminNew-device->queryPlantsInfoEs】");
        if (res.err == 0) {
          // console.log("项目列表", res.dat);

          // 赋值
          this.proList = res.dat.info;
          this.loadingdevice = false;

          // // console.log("项目", res.dat.info[0]);
          // // 默认显示第一个
          // this.proCurrentPid = res.dat.info[0].pid;
          // this.proCurrentName = res.dat.info[0].pname;
          // // 请求第一个项目下设备列表
          // let param2 = {
          //   // plantid OR pid ???
          //   plantid: this.proCurrentPid,
          //   // pid: this.proCurrentPid,
          //   devtype: 2304,
          //   page: 0,
          //   pagesize: 50,
          //   orderBy: 'descfocus'
          // };

          // this.$request.get("webQueryDeviceEs", param2).then(res => {
          //   if (res.err == 0) {
          //     this.loadingdevice = false;
          //     // console.log("设备", res.dat.device);
          //     this.deviceList = res.dat.device;
          //   } else {
          //     this.loadingdevice = false;
          //     // this.$message.warning(this.$t(`errCode.${res.err}`));
          //     this.deviceList = [];
          //   }
          // });
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          // 赋值
          this.proList = [];
          this.loadingdevice = false;
        }
      });
    },
    loadmoreProjectList() {
      this.paginationPro.currentPage++;

      let param = {
        i18n: this.$lang.currentLang,
        devtype: 2304,
        // 项目过多时处理
        // page: 0,
        // pagesize: 10,
        page: this.paginationPro.currentPage - 1,
        pagesize: this.paginationPro.pagesize,
        // 项目ID plantid
        // plantName: this.search.search,
      };

      // Loading
      this.loadingMorePro = true;

      // queryPlantsInfoEs => queryPlantCollDevEs
      this.$request.get("queryPlantsInfoEs", param).then((res) => {
        // console.log("【adminNew-device->queryPlantsInfoEs】");
        if (res.err == 0) {
          // console.log("[Loadmore-res.dat]", res.dat);
          // console.log("[Loadmore-base(old)]", JSON.parse(JSON.stringify(this.proList)));
          // console.log("[Loadmore-add]", JSON.parse(JSON.stringify(res.dat.info)));

          // 追加
          this.proList = this.proList.concat(res.dat.info);
          this.loadingMorePro = false;

          // // console.log("项目", res.dat.info[0]);
          // // 默认显示第一个
          // this.proCurrentPid = res.dat.info[0].pid;
          // this.proCurrentName = res.dat.info[0].pname;
          // // 请求第一个项目下设备列表
          // let param2 = {
          //   // plantid OR pid ???
          //   plantid: this.proCurrentPid,
          //   // pid: this.proCurrentPid,
          //   devtype: 2304,
          //   page: 0,
          //   pagesize: 50,
          //   orderBy: 'descfocus'
          // };

          // this.$request.get("webQueryDeviceEs", param2).then(res => {
          //   if (res.err == 0) {
          //     this.loadingdevice = false;
          //     // console.log("设备", res.dat.device);
          //     this.deviceList = res.dat.device;
          //   } else {
          //     this.loadingdevice = false;
          //     // this.$message.warning(this.$t(`errCode.${res.err}`));
          //     this.deviceList = [];
          //   }
          // });
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          // 追加
          this.proList = this.proList.concat([]);
          this.loadingMorePro = false;
        }
      });
    },
    // 切换项目
    changePro(proCurrentPid) {
      this.proCurrentPid = proCurrentPid;
      let param = {
        // plantid OR pid ???
        pid: proCurrentPid,
        // pid: proCurrentPid,
        devtype: 2304,
        page: 1,
        pageSize: 50,
        orderBy: "descfocus",
      };
      this.loadingdevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then((res) => {
        if (res.code == 0) {
          this.loadingdevice = false;
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceList = this.Fnreturndev(res);
        } else {
          this.loadingdevice = false;
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.deviceList = [];
        }
      });
    },
    //获取项目下设备列表数据
    // status，devtype(2304)， plantid，page(0)，pagesize (100)
    getDeviceList() {
      let param = {
        // ...this.search,
        devtype: 2304,
        page: 1,
        pageSize: 100,
        orderBy: "descfocus",
      };
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then((res) => {
        if (res.code == 0) {
          this.deviceList = this.Fnreturndev(res);
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.deviceList = [];
        }
      });
    },
    toggleDevice(info) {
      this.$store.commit("saveDeviceInfo", { ...info, deviceSn: info.deviceSn || info.sn });
    },
    handleCommand(command) {
      this.$message("点击" + command);
    },
    // 关注 (info)
    // pn/sn/devaddr/devcode/focus(true,false)
    followDevice(info) {
      // this.focus = !this.focus;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        // focus: info.focus == undefined ? true : info.focus,
        focus: !info.focus,
      };
      this.$request.get("editDeviceFocusEs", param).then((res) => {
        if (res.err === 0) {
          // 保存设备信息
          this.$store.commit("saveDeviceInfo", {
            pn: info.pn,
            sn: info.sn,
            deviceSn: info.deviceSn || info.sn,
            devaddr: info.devaddr,
            devcode: info.devcode,
            status: info.status,
            devalias: info.devalias,
            profitToday: info.profitToday,
            profitTotal: info.profitTotal,
            sellProfitToday: info.sellProfitToday,
            sellProfitTotal: info.sellProfitTotal,
            buyProfitToday: info.buyProfitToday,
            buyProfitTotal: info.buyProfitTotal,
            focus: !info.focus,
            // pid: info.pid,
          });
          // 通知设备关注更新
          this.$store.state.event.updateFocus = true;
          // 通知项目列表更新
          this.$store.state.event.updateProjectList = true;
          this.getProjectList();
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 添加数采器成功回调
    handleCreateSuc() {
      // this.$message.success(this.$t("datalogger.addSuc"));
      // this.dataloggerTipMsg = val;
      this.dataloggerAddSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      // this.$router.push({
      //   path:'/generalNew/setting/datalogger',
      //   query: {'notice': 'Suc'}
      // });
    },
    // 添加数采器失败回调
    handleCreateFail(val) {
      this.dataloggerTipMsg = val;
      this.dataloggerAddFailVisible = true;
      // this.$router.push({
      // 	path:'/generalNew/setting/datalogger',
      // 	query: {'notice': 'Fail', 'noticeVal': val}
      // });
    },
    // 进入项目管理
    enterProject() {
      // this.$router.push({path:"/generalNew/project"});
      this.$router.push({ path: "/adminNew/project" });
    },
    // 新建项目
    createProject() {
      this.createProjectVisible = true;
      this.pFormData.name = "";
    },
    submitCreateProject() {
      let param = {
        name: this.pFormData.name,
        picBig: this.pFormData.picBig,
        picSmall: this.pFormData.picSmall,
      };
      this.$request.get("addPlantEs", param).then((res) => {
        if (res.err == 0) {
          // this.$message.success(this.$t("project.modifySuc"));
          // 通知项目列表更新
          this.$store.state.event.updateProjectList = true;
          this.getProjectList();
          this.createProjectVisible = false;
          this.createProjectSucVisible = true;
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          this.createProjectFailVisible = true;
        }
      });
    },
    // 侧栏按钮===================
    // 侧栏点击切换=》进入设备详情页
    enterSingleBox(info) {
      // 先清空Store中的plantidCur(后续需要再设置)
      this.$store.commit("savePlantidCur", {
        plantidCur: "",
      });
      // 先清空Store中的curIsFollow(后续需要再设置)
      this.$store.commit("saveCurIsFollow", {
        curIsFollow: false,
      });

      // console.log("click->info",info);
      this.devCurrentSn = info.sn;
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        devalias: info.devalias,
        status: info.status,
        focus: info.focus,
        usr: info.usr,
        uid: info.uid,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
      });
      // 通知显示设备信息页
      // this.$emit('noticeDeviceBox', false);
      this.$emit("noticeSingleBox", true);
    },
    // 侧栏点击切换=》进入设备列表页
    enterDeviceBox(info) {
      // 先清空Store中的plantidCur(后续需要再设置)
      this.$store.commit("savePlantidCur", {
        plantidCur: "",
      });
      // 先清空Store中的curIsFollow(后续需要再设置)
      this.$store.commit("saveCurIsFollow", {
        curIsFollow: false,
      });

      // 点击按钮切换
      if (info.index) {
        this.currentBtnViewIndex = info.index;
        this.currentProId = "";
      }
      // 点击项目名称切换
      if (info.pid) {
        this.currentBtnViewIndex = "";
        this.currentProId = info.pid;
        // 保存项目ID到Store
        this.$store.commit("savePlantidCur", {
          plantidCur: info.pid,
        });
      }
      // 通知显示设备列表页
      this.$emit("noticeDeviceBox", true);
    },
    // 侧栏点击切换=》进入数采器列表页
    enterDataloggerBox(info) {
      // 先清空Store中的plantidCur(后续需要再设置)
      this.$store.commit("savePlantidCur", {
        plantidCur: "",
      });
      // 先清空Store中的curIsFollow(后续需要再设置)
      this.$store.commit("saveCurIsFollow", {
        curIsFollow: false,
      });

      // 点击按钮切换
      if (info.index) {
        this.currentBtnViewIndex = info.index;
        this.currentProId = "";
      }
      // 通知显示数采器列表页
      this.$emit("noticeDataloggerBox", true);
    },
    // // 侧栏点击切换=》进入关注列表页
    // enterFollowBox(info) {
    //   // 先清空Store中的plantidCur(后续需要再设置)
    //   this.$store.commit("savePlantidCur", {
    //     plantidCur: "",
    //   });
    //   // 先清空Store中的curIsFollow(后续需要再设置)
    //   this.$store.commit("saveCurIsFollow", {
    //     curIsFollow: false,
    //   });

    //   // 点击按钮切换
    //   if (info.index) {
    //     this.currentBtnViewIndex = info.index;
    //     this.currentProId = "";
    //   }
    //   // 点击按钮筛选
    //   if (info.currentIsFollow) {
    //     // this.currentBtnViewIndex = info.index;
    //     // this.currentProId = '';
    //     this.$store.commit("saveCurIsFollow", {
    //       curIsFollow: info.currentIsFollow,
    //     });
    //   }

    //   // 通知显示关注列表页(和设备列表页共用)
    //   // this.$emit('noticeFollowBox', true);
    //   this.$emit("noticeDeviceBox", true);
    // },
    // 侧栏点击切换=》进入项目列表页
    enterProjectBox(info) {
      // 先清空Store中的plantidCur(后续需要再设置)
      this.$store.commit("savePlantidCur", {
        plantidCur: "",
      });
      // 先清空Store中的curIsFollow(后续需要再设置)
      this.$store.commit("saveCurIsFollow", {
        curIsFollow: false,
      });

      // 点击按钮切换
      if (info.index) {
        this.currentBtnViewIndex = info.index;
        this.currentProId = "";
      }

      // 点击项目名称切换
      // if(info.pid){
      //   this.currentBtnViewIndex = '';
      //   this.currentProId = info.pid;
      //   // 保存项目ID到Store
      //   this.$store.commit("savePlantidCur", {
      //     plantidCur: info.pid,
      //   });
      // }

      // 通知显示设备列表页
      this.$emit("noticeProjectBox", true);
    },
    // 朔日导出记录
    enterRuoRiExportRecordsBox(info) {
      // 先清空Store中的plantidCur(后续需要再设置)
      this.$store.commit("savePlantidCur", {
        plantidCur: "",
      });
      // 先清空Store中的curIsFollow(后续需要再设置)
      this.$store.commit("saveCurIsFollow", {
        curIsFollow: false,
      });
      // 点击按钮切换
      if (info.index) {
        this.currentBtnViewIndex = info.index;
        this.currentProId = "";
      }
      // 通知显示设备列表页
      this.$emit("noticeRuoRiExportRecordsBox", true);
    },
    // 上传图片
    uploadImage(event) {
      let file = event.target.files[0];
      if (file.size > 1 * 1024 * 1024) {
        this.$message.error(this.$t("createPlant.fileExceed"));
        return;
      }
      this.$request.uploadImage(file).then((res) => {
        if (res.err === 0) {
          // console.log('侧边栏新建项目上传图片成功', res.dat)
          this.$message.success(this.$t("createPlant.uploadSuccess"));
          this.upbtnVisible = false;
          // this.$nextTick(() => {
          //   this.upbtnVisible = true;
          // });
          this.pFormData.picSmall = res.dat.picSmall;
          // this.$emit("update:picBig", res.dat.picBig)
          // this.$emit("update:picSmall", res.dat.picSmall)
        }
      });
    },
    // 查询此管理员的厂家编号vcode用于控制权限
    getVcodeData() {
      this.$request.get("queryVendorCode").then((res) => {
        if (res.err == 0) {
          this.vcodeBox = res.dat.vendorcode[0].code;
          if (this.vcodeBox == "08" && this.$store.state.user.role == 2)
            this.closeSidebar();
        }else{
          if (this.$store.state.user.riyueyuanPermissionMark && this.$store.state.user.role == 2)
            this.closeSidebar();
        }
      });
    },
    // 管理员-打开控制权限按钮 =====
    editDeviceControl() {
      // console.log("管理员-打开控制权限");
      this.editDeviceControlVisible = true;
      this.CheckAllPerson = false;
      this.CheckNoPerson = false;
      this.CheckAllAdmin = false;
      this.CheckNoAdmin = false;
      this.$request.get("queryDeviceDevcodes").then((res) => {
        if (res.err == 0) {
          res.dat.devcode.forEach((item) => {
            item.desc = item.devcode + " -" + item.desc;
          });
          this.protocolAllData = res.dat.devcode;
          this.searchProtocol = this.protocolAllData[0].devcode;
          this.getProtocolData();
        } else {
          this.checkStatueData = [];
          this.protocolDataShow = false;
          // this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //通过协议查询协议里面的控制项
    getProtocolData() {
      this.protocolDataShow = true;
      this.$request
        .get("queryDeviceCtrlFieldForDist", {
          vcode: this.vcodeBox,
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          i18n: this.$lang.currentLang,
        })
        .then((res) => {
          if (res.err == 0) {
            this.checkStatueData = res.dat.field;
            this.protocolIdBox = [];
            this.protocolNameBox = [];
            let personProtocolBox = [],
              adminProtocolBox = [];
            res.dat.field.forEach((item) => {
              if (item.visable) {
                personProtocolBox.push(item.name);
              }
              if (item.distributorPermissionFlag) {
                adminProtocolBox.push(item.name);
              }
              this.protocolIdBox.push(item.id);
              this.protocolNameBox.push(item.name);
            });
            this.checkPersonData = personProtocolBox;
            this.checkAdminData = adminProtocolBox;
          } else {
            this.checkStatueData = [];
            this.protocolDataShow = false;
          }
        });
    },
    //电站业主全部勾选
    checkAllPerson() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          visable: true,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckAllPerson = true;
            this.CheckNoPerson = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //电站业主全部取消
    checkNoPerson() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          visable: false,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckAllPerson = false;
            this.CheckNoPerson = true;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //管理员全部勾选
    checkAllAdmin() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          distributorPermissionFlag: true,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckNoAdmin = false;
            this.CheckAllAdmin = true;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //管理员全部取消
    checkNoAdmin() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          distributorPermissionFlag: false,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckNoAdmin = true;
            this.CheckAllAdmin = false;
          } else {
            this.$message.error(res.err);
          }
        });
    },
    //管理员点击单个的控制权限
    protoclAdminChange(val) {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          id: val.id,
          vcode: this.vcodeBox,
          distributorPermissionFlag: !val.distributorPermissionFlag,
        })
        .then((res) => {
          if (res.err == 0) {
            this.CheckAllAdmin = false;
            this.CheckNoAdmin = false;
            this.getProtocolData();
            this.isIndeterminateAdmin = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //电站业主点击单个的控制权限
    protoclPersonChange(val) {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          id: val.id,
          vcode: this.vcodeBox,
          visable: !val.visable,
        })
        .then((res) => {
          if (res.err == 0) {
            this.CheckNoPerson = false;
            this.CheckAllPerson = false;
            this.getProtocolData();
            this.isIndeterminatePerson = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    closeSidebar() {
      if (this.sideBarCollapse) {
        document.getElementById("sidebar-list").classList.add("collapsed");
      } else {
        document.getElementById("sidebar-list").classList.remove("collapsed");
      }
      this.sideBarCollapse = !this.sideBarCollapse;
    },
  },
};
</script>
<style lang="less" scoped>
.adminDeviceSidebarNew {
  position: relative;
  // 滚动条
  ::-webkit-scrollbar {
    width: 0px;
    background-color: transparent;
  }

  // 弹窗滚动条
  // .dialogModalNew {
  //   ::-webkit-scrollbar {
  //     width: 3px;
  //     height: 3px;
  //     background-color: transparent;
  //   }
  // }
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .sidebar-list {
    box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.2);
    height: 100%;
    padding: 0 29px;
    background-color: rgb(34, 45, 53);
    color: #ffffff;
    font-size: 16px;
    padding-top: 20px;
    position: relative;
    // 解决侧栏列表滚动问题
    display: flex;
    flex-direction: column;

    // 侧栏加载更多
    .sidebarLoadmore {
      width: 206px;
      line-height: 50px;
      text-align: center;
      font-size: 14px;
      color: rgba(51, 255, 182, 1);
      cursor: pointer;

      // 加载数据时遮罩
      // /deep/.el-loading-mask {
      //   background-color: rgb(34, 45, 53, .5);
      // }
      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
        font-size: 18px;
      }

      // /deep/.el-loading-spinner .path {
      //   stroke: @primaryTextColor;
      // }
    }

    .sidebartableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        height: 100vh;
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner {
        top: 10vh;
        margin-top: 0px;
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
        font-size: 18px;
      }
    }

    .sidebarViewBox {
      .titletype {
        font-size: 12px;
        color: #adb9c0;
        padding-bottom: 16px;
      }
      // 侧栏查看设备列表
      // .ico-view-device {
      //   background: linear-gradient(180deg, rgba(79, 160, 247, 1) 0%, rgba(50, 125, 245, 1) 100%);
      // }

      // .ico-view-datalogger {
      //   background: linear-gradient(180deg, rgba(146, 230, 124, 1) 0%, rgba(100, 194, 101, 1) 100%);
      // }

      // .ico-view-follow {
      //   background: linear-gradient(180deg, rgba(241, 183, 68, 1) 0%, rgba(241, 152, 55, 1) 100%);
      // }

      // .ico-view-project {
      //   background: linear-gradient(180deg, rgba(240, 147, 255, 1) 0%, rgba(169, 63, 171, 1) 100%);
      // }

      .ico-view {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 5px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
        // margin-top: 2px;
        i {
          color: #ffffff;
          font-size: 20px;
        }
      }

      .text-view {
        color: rgba(255, 255, 255, 0.7);
        font-size: 16px;
        margin-left: 10px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .btn-view {
        width: 206px;
        // height: 40px;
        border-radius: 6px;
        background: rgba(34, 45, 53, 1);
        display: flex;
        justify-content: flex-start;
        // align-items: center;
        padding: 8px 10px;
        margin-bottom: 20px;
        cursor: pointer;

        &.activeBtnView {
          background: rgba(43, 56, 66, 1);
          i {
            color: @primaryTextColor;
          }

          .text-view {
            color: @primaryTextColor;
          }
        }
      }
    }

    // 添加按钮
    /deep/.el-button {
      display: block;
      width: 100%;
      height: 38px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 16px;
      margin-bottom: 20px;
      padding: 0;
    }

    /deep/.el-button .el-icon-add:before {
      content: "";
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(../../../assets/img/general/Icon_Device_Add.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }

    /deep/.el-icon-add {
      vertical-align: middle;
    }

    // 分割线
    .spliteline {
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      margin-bottom: 20px;
    }

    // 搜索框
    /deep/.search-input.el-input {
      display: block;
      font-size: 16px;
    }

    /deep/.search-input.el-input .el-input__inner {
      margin-bottom: 20px;
      height: 42px;
      padding-left: 42px;
      color: #ffffff;
    }

    /deep/.search-input .el-input__inner {
      background-color: transparent;
      border-radius: 0;
      border: 1px solid @primaryTextColor;
    }

    /deep/.search-input .el-input__inner:hover {
      border: 1px solid @primaryTextColor;
    }

    /deep/.search-input .el-input__inner:focus {
      border: 1px solid @primaryTextColor;
    }

    // .el-input__suffix
    /deep/.search-input .el-input__prefix {
      left: 14px;
      height: auto;
    }

    /deep/.search-input .el-input__icon {
      color: #ffffff;
      font-size: 20px;
      line-height: 42px;
      margin-left: -6px;
    }

    /deep/.search-input input::-webkit-input-placeholder {
      font-weight: 100;
      color: #ffffff;
      font-size: 14px;
    }

    /deep/.search-input input::-moz-input-placeholder {
      font-weight: 100;
      color: #ffffff;
      font-size: 14px;
    }

    /deep/.search-input input::-ms-input-placeholder {
      font-weight: 100;
      color: #ffffff;
      font-size: 14px;
    }

    // .searchbox {}
    // 项目列表
    /deep/.el-table .cell {
      // padding: 0 40px 0 0;
      padding: 0px;
    }

    /deep/.el-table__expand-icon > .el-icon {
      margin-top: -6px;
    }

    /deep/.el-table .cell,
    /deep/.el-table th div {
      overflow: inherit;
    }

    /deep/.el-table__body .el-table__row .el-table_1_column_2 .cell.el-tooltip {
      font-size: 16px;
      text-align: right;
    }

    /deep/.el-table__body .el-table__row .el-table_2_column_4 .cell.el-tooltip {
      font-size: 16px;
      text-align: right;
    }

    /deep/.el-table__body .el-table__row.expanded .cell.el-tooltip {
      color: @primaryTextColor;
    }

    /deep/.el-table__body .el-table__row.expanded .cell.el-tooltip {
      color: @primaryTextColor;
    }

    /deep/.el-table__body
      .el-table__row.expanded
      .el-table__expand-icon
      > .el-icon {
      color: @primaryTextColor;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background: transparent;
      border: none;
      color: #ffffff;
    }

    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0;
    }

    /deep/.el-table__expanded-cell[class*="cell"] {
      padding: 0;
    }

    /deep/.el-table--scrollable-x .el-table__body-wrapper:last-child {
      overflow-x: hidden;
    }

    /deep/.el-table .cell.el-tooltip {
      text-align: right;
      padding: 0;
    }

    /deep/.el-table th,
    .el-table tr {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table--enable-row-transition .el-table__body td {
      border: none;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table__row.hover_row {
      border: none;
    }

    /deep/.el-table__body-wrapper .el-table__expand-icon > .el-icon {
      color: #ffffff;
    }

    .viewbox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      // width: 247px;
      /deep/.el-select .el-input .el-input__icon.el-icon-circle-close {
        margin-top: 5px;
      }

      .totalNum {
        display: inline-block;
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        max-width: 206px;
      }

      .screen {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // width: 50px;
        max-width: 50%;
        min-width: 42%;
        height: 34px;
        line-height: 34px;
        position: relative;

        .shaixuan {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          line-height: 34px;
          background: #202d35;
          color: #ffffff;
          font-size: 16px;
          z-index: 1;
          cursor: pointer;
        }

        .el-select {
          position: absolute;
          top: 0;
          left: 0;
        }

        /deep/.el-input__inner {
          background: #202d35;
          border: none;
          padding: 0px 5px;
          font-size: 14px;
          color: #ffffff;
        }

        /deep/.el-input__prefix,
        /deep/.el-input__suffix {
          top: -4px;
          // right: -20px;
          right: 0px;
          background: #202d35;
        }

        /deep/.el-icon-arrow-up:before {
          content: "";
          display: inline-block;
          width: 20px;
          height: 24px;
          background: url(../../../assets/img/general/Icon_Down.png);
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          transform: rotate(180deg);
        }

        /deep/.el-select .el-input .el-select__caret.is-reverse {
          transform: rotate(180deg);
        }
      }

      .mode {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .modeleft {
          background-image: url(../../../assets/img/general/Icon_Mode_Dark_L.png);
        }

        .showmodeleft {
          background-image: url(../../../assets/img/general/Icon_Mode_Light_L.png);
        }

        .moderight {
          background-image: url(../../../assets/img/general/Icon_Mode_Dark_R.png);
        }

        .showmoderight {
          background-image: url(../../../assets/img/general/Icon_Mode_Light_R.png);
        }

        .modecell {
          width: 34px;
          height: 34px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }

    // 关注
    .device-item-follow {
      // display: none;
      position: absolute;
      top: 0px;
      right: 0px;
      width: 40px;
      height: 40px;
      border-radius: 0 0 0 100%;

      // background:#858F97;
      // 是否关注
      .followno {
        width: 20px;
        height: 20px;
        background-image: url(../../../assets/img/general/Icon_Operate_Follow_Light.png);
      }

      .followyes {
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/img/general/Icon_Operate_Follow_Dark.png);
      }

      .followbase {
        display: inline-block;
        position: absolute;
        top: 4px;
        right: 4px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        vertical-align: middle;
      }
    }

    .device-item {
      position: relative;
      width: 100%;
      height: 124px;
      background: url(../../../assets/img/general/device-item-bgi.jpg) no-repeat;
      background-size: cover;
      background-position: center;
      margin-bottom: 25px;
      cursor: pointer;

      .device-item-mask {
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 62px;
        background: rgba(34, 45, 53, 0.8);
      }

      .device-item-info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 62px;
        padding: 0 15px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 18px;
        text-align: left;

        .device-item-namebox {
          display: block;
          margin-top: 6px;
          width: 100%;
          text-align: left;

          .device-item-name {
            display: inline-block;
            width: 70%;
            font-family: Microsoft YaHei;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;

            &.activePro {
              color: @primaryTextColor;
            }
          }
        }

        .device-item-idbox {
          display: block;
          margin-top: 2px;
          width: 100%;

          .device-item-id {
            display: inline-block;
            width: 102%;
            font-family: Microsoft YaHei;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }

    .device-item-easy {
      width: 100%;
      height: 55px;
      border-bottom: 1px solid #424e56;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;

      .device-item-namebox {
        display: block;
        margin-top: 6px;
        text-align: left;
        width: 85%;

        .device-item-name {
          display: inline-block;
          width: 70%;
          font-family: Microsoft YaHei;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          &.activePro {
            color: @primaryTextColor;
          }
        }
      }

      .device-item-follow {
        .followbase {
          top: 6px;
        }
      }
    }

    .device-item:hover,
    .device-item-easy:hover {
      .showFollow {
        display: inline-block;
      }

      .device-item-follow {
        background: #858f97;
      }
    }

    .status-icon {
      width: 15px;
      height: 15px;
      margin-right: 10px;
      vertical-align: text-top;
    }

    .project-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(34, 45, 53, 1);
      box-shadow: 0px 4px 23px rgba(58, 77, 90, 0.3) inset;
      z-index: 3;

      .project-create,
      .project-manage {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      /deep/button {
        display: block;
        width: 100%;
        height: 56px;
        line-height: 56px;
        border: none;
        border-radius: 0px;
        background: rgba(34, 45, 53, 1);
        color: #ffffff;
        font-size: 14px;
        padding: 0px;
        margin-bottom: 0px;
        box-shadow: 0px 4px 23px rgba(58, 77, 90, 0.3) inset;
        cursor: pointer;

        i {
          font-size: 24px;
          color: @primaryTextColor;
          margin-right: 8px;
          // vertical-align: middle;
        }
      }

      .project-line {
        width: 0.1px;
        height: 30px;
        border-width: 0.1px;
        border-style: solid;
        border-image-source: radial-gradient(
          57% 44.45% at 50% 50%,
          rgba(255, 255, 255, 1) 0%,
          rgba(34, 45, 53, 0) 100%
        );
        border-image-slice: 1;
        border-image-outset: 0.1px;
      }
    }
  }

  .el-dropdown-pro {
    width: 100%;
    max-width: 206px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .showlabel {
      width: 100%;
      max-width: 247px;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0px;

      .countbox {
        width: 90%;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .pnamebox {
          // display: block;
          // text-align: left;
          max-width: 65%;
          // padding-top: 5px;
          margin-right: 5px;

          .pname {
            display: inline-block;
            padding-top: 5px;
            width: 100%;
            font-family: Microsoft YaHei;
            font-size: 16px;
            font-weight: bold;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 设备列表
  .proDeviceList {
    /deep/.el-table__empty-block {
      height: auto;
    }

    // 设备管理=》侧栏项目
    .group-box {
      position: absolute;
      // left:-20px;
      margin-top: -12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 206px;

      .group-label {
        display: flex;
        justify-content: flex-start;
        // justify-content: space-between;
        width: 100%;
        text-align: left;

        // margin-left: -20px;
        i {
          font-size: 20px;
        }

        .label-name {
          display: inline-block;
          width: 60%;
          // 处理分组名称过长
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          cursor: pointer;
          margin-left: 10px;
        }

        .label-num {
          display: inline-block;
          text-align: right;
          // margin-left: 5px;
          // 计数值超大时
          // line-height: 1;
        }

        // 激活
        &.activeGroup {
          color: @primaryTextColor;
        }
      }
    }
  }

  // 新建项目(上传图片)
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  //控制权限里面的样式
  .editControl {
    margin-top: -20px;
    margin-bottom: -2px;
    display: flex;
    flex: 1;
    flex-direction: column;

    // 滚动条
    // ::-webkit-scrollbar {
    //   width: 3px;
    //   background-color: transparent;
    // }
    .searchprotocol {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;

      .searchName {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        width: 130px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
      }

      .el-select {
        margin-left: 0px;
        width: 500px;
        // overflow: auto;
      }
    }

    .personProtocol,
    .adminProtocol {
      display: flex;
      flex-direction: row;
      min-height: 180px;

      // border: 1px solid #d9d9d9;
      .contentLeft {
        flex: 1;
        // margin: auto;
        font-family: "Times New Roman", "Microsoft YaHei";
        font-size: 16px;
        letter-spacing: 1.5px;
        height: 100%;
        width: 130px;
        // padding: 10px;
        color: rgba(255, 255, 255, 0.7);

        .top {
          // height: 25px;
          // line-height: 25px;
          // text-align: center;
          // border-bottom: 1px solid #d9d9d9;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          text-align: right;
          font-size: 14px;

          /deep/.el-checkbox__label {
            color: rgba(255, 255, 255, 1);
            // width: 50px;
            width: auto;
            font-size: 14px;
          }

          /deep/.el-checkbox__inner {
            width: 14px;
            height: 14px;
            border-radius: 4px;
            border: 1px solid rgba(190, 190, 190, 1);
            background: rgba(255, 255, 255, 1);
          }

          /deep/.el-checkbox__inner:hover,
          /deep/.el-checkbox__inner:focus {
            border: 1px solid rgba(51, 255, 182, 1);
          }

          /deep/.el-checkbox {
            margin-right: 10px;
            margin-top: 30px;
          }

          /deep/.el-checkbox
            .el-checkbox__input.is-checked
            .el-checkbox__inner {
            border: 1px solid rgba(51, 255, 182, 1);
            background: @primaryTextColor;
          }
        }
      }

      .contentRight {
        flex: 7;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        display: flex;
        flex-direction: column;

        // .top {
        //   height: 25px;
        //   line-height: 25px;
        //   text-align: center;
        //   border-bottom: 1px solid #d9d9d9;
        //   /deep/.el-checkbox__label {
        //     color: rgba(255, 255, 255, 1);
        //     width: 50px;
        //   }
        //   /deep/.el-checkbox__inner:hover,
        //   /deep/.el-checkbox__inner:focus {
        //     border: 1px solid @primaryTextColor;
        //   }
        //   /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        //     background: @primaryTextColor;
        //     border: 1px solid @primaryTextColor;
        //   }
        // }
        .noData {
          margin: 40px auto;
          font-size: 14px;
          color: #909399;
        }

        .protoclContents {
          flex: 1;
          max-height: 300px;
          overflow: auto;

          .checkboxUnit {
            // font-family: "微软雅黑";
            // padding-left: 6px;
            padding: 10px;
            margin: 0;

            // border-right: 0.5px solid #eee;
            /deep/.el-checkbox__label {
              color: rgba(255, 255, 255, 1);
              font-size: 14px !important;
              padding-left: 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 136px !important;
              padding-top: 5px;
            }

            /deep/.el-checkbox__inner:hover,
            /deep/.el-checkbox__inner:focus {
              border: 1px solid rgba(51, 255, 182, 1);
            }

            /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
              border: 1px solid rgba(51, 255, 182, 1);
              background: @primaryTextColor;
            }
          }
        }

        /deep/.el-checkbox__inner {
          width: 14px;
          height: 14px;
          border-radius: 4px;
          border: 1px solid rgba(190, 190, 190, 1);
          background: rgba(255, 255, 255, 1);
        }

        /deep/ .el-checkbox__inner::after {
          top: 1px;
          left: 4px;
        }

        // 滚动条
        ::-webkit-scrollbar {
          width: 3px;
          height: 3px;
          background-color: transparent;
        }
      }
    }

    .adminProtocol {
      margin-top: 15px;
    }
  }
}

// 滚动条
// ::-webkit-scrollbar {
//   width: 0px;
//   background-color: transparent;
// }

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
// 筛选下拉菜单
.select-search-pro {
  width: 200px;
  background: #222d35;
  font-family: Microsoft YaHei;
  border-radius: 6px;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  .el-select-dropdown__wrap {
    max-height: 546px;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__title {
    padding-left: 16px;
    font-size: 14px;
    color: #ffffff;
    border-bottom: 1px solid #424e56;
    line-height: 39px;
    margin-top: 10px;
  }

  .el-select-dropdown__item {
    padding-left: 16px;
    font-size: 14px;
    text-align: left;
    background: #222d35;
    color: #ffffff;
    font-family: Microsoft YaHei;
  }

  .el-select-group__wrap {
    padding-bottom: 0px;
  }

  // .el-select-dropdown__item.hover {
  // }
  .el-select-dropdown__item:hover {
    background: #222d35;
    color: #ffffff;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin-right: 5px;
    position: absolute;
    top: 6px;
    right: 12px;
  }
}

// 切换项目的悬浮框
.el-dropdownmenu-pro {
  // overflow: hidden;
  background: #202d35;
  color: #ffffff;
  border-radius: 6px;
  border: none;
  padding: 10px 0px;
  // min-width: 100px;
  // min-height: 30px;
  // 分页加载
  max-height: 300px;

  .el-dropdown-menu__item {
    background: #202d35;
    color: #ffffff;
    border: none;
    font-size: 16px;
  }

  .el-dropdown-menu__item.selected,
  .el-dropdown-menu__item:hover,
  .el-dropdown-menu__item:focus {
    background: #202d35;
    color: @primaryTextColor;
    border: none;
  }

  .el-dropdown-menu__item:hover {
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-dropdown-menu__item:not(:last-child) {
    border: none;
  }

  .popper__arrow {
    display: none;
  }

  &.el-popper[x-placement^="right"] {
    margin-left: 5px;
  }

  // 滚动条
  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
    background-color: transparent;
  }
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}
.closeBtn {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 100%;
  color: rgba(19, 195, 156, 1);
  background-color: #39505f;
  position: absolute;
  right: -20px;
  top: 49%;
  z-index: 99;
  cursor: pointer;
  user-select: none;
}
.collapsed {
  display: none !important;
}
#sidebar-list {
  transition: all 0.3s ease;
}
</style>
